import { render } from "./choose_your_legacy_section.html?vue&type=template&id=b590cad0&external"
import script from "./choose_your_legacy_section.js?vue&type=script&lang=js&external"
export * from "./choose_your_legacy_section.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__